<div class="template">
    <div *ngIf="!error && configuration" class="image-url ">
        <div *ngIf="configuration.assetUrl" class="asset-wrapper fixed-asset" style="background-color: white;">
            <div *ngIf="configuration.titleText" id="title" class="header-title">{{renderTitle(configuration.titleText)}}</div>
            <div *ngIf="configuration.description" class="subtext">{{configuration.description}}</div>
        </div>
        <div class="container">
            <div class="value-propositions" *ngIf="configuration.valuePropositions">
                <div *ngFor="let proposition of configuration.valuePropositions; let isLast = last" class="value-proposition">
                    <div *ngIf="hasVpIcons && proposition.iconUrl" class="vp-icon">
                        <img class="vp-icon-asset" [src]="proposition.iconUrl">
                    </div>
                    <div class="vp-text">
                        <div class="vp-title">{{proposition.title}}</div>
                        <div class="vp-description">{{proposition.description}}</div>
                        <img class="asset" [src]="proposition.assetUrl">
                        <div class="spacer" *ngIf="!isLast" style="height: 1px; background-color: #E0E3E6;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  